// extracted by mini-css-extract-plugin
export default {"menuGroupItem":"MenuItem_menuGroupItem__57bE-","menuGroupItemCompleted":"MenuItem_menuGroupItemCompleted__x42Ef","menuGroupItemActive":"MenuItem_menuGroupItemActive__LZMll"};